import React from 'react';
import { useRef } from 'react';

import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import InvoiceFooter from './InvoiceFooter';
import InvoiceHeader from './InvoiceHeader';
import InvoiceMainTable from './InvoiceMainTable';
import ProfileHeader from './ProfileHeader';
import ThankMessage from './ThankMessage';

const InvoiceContainer = () => {
  const printDiv = useRef('');

  return (
    <>
      <Container fluid={true}>
        <Breadcrumbs justify='end' pageTitle='Invoice' parent='Ecommerce' title='Invoice' />
      </Container>
      <Container className='invoice'>
        <Row>
          <Col sm='12'>
            <div ref={printDiv}>
              <Card>
                <CardBody>
                  <InvoiceHeader />
                  <ProfileHeader />
                  <InvoiceMainTable />
                  <ThankMessage />
                  <InvoiceFooter printParent={printDiv} />
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default InvoiceContainer;
